var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-filtered-search',{attrs:{"placeholder":_vm.s__('Jobs|Filter jobs'),"available-tokens":_vm.tokens,"value":_vm.filteredSearchValue},on:{"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }